/**
 * ABP product hero (sections/abp-product-hero.liquid) add-on behavior.
 *
 * The carousel, thumbnails, variant radio sync, per-stick price and the
 * giveaway badge are handled by the shared assets/rtnu-pdp-hero.js. That
 * script only updates the bonus-entries counter inside `#buy`; in this
 * section `#buy` is the buy box wrapper and the bonus entries render further
 * down inside the checkout block, so this script keeps that counter in sync
 * on variant change (matching the section's original inline script).
 *
 * Boots once per `[data-rtnu-abp-hero]` root. Reads:
 *   data-form-id  product form id
 */
(() => {
  if (window.__rtnuAbpHeroBound) return;
  window.__rtnuAbpHeroBound = true;

  const updateBonusEntries = (form, subscriptionCents, onetimeCents) => {
    const bonus = form.querySelector('.rtnu-product__bonus-entries');
    if (!bonus) return;

    bonus.dataset.onetimePrice = onetimeCents;
    bonus.dataset.subscriptionPrice = subscriptionCents;

    const isSubscription = form.querySelector('[data-rtnu-selling-plan][name="selling_plan"]') !== null;
    const multiplier = parseFloat(bonus.dataset.entriesMultiplier) || 10;
    const priceCents = isSubscription ? subscriptionCents : onetimeCents;
    const count = bonus.querySelector('.rtnu-product__bonus-entries-count');
    if (count) count.textContent = Math.round((priceCents / 100) * multiplier);
  };

  const initHero = (root) => {
    if (root.dataset.rtnuAbpHeroReady) return;
    root.dataset.rtnuAbpHeroReady = 'true';

    const { formId } = root.dataset;
    const form = formId ? root.querySelector(`#${CSS.escape(formId)}`) : null;
    if (!form) return;

    form.querySelectorAll('.rtnu-product__variants .rtnu-option').forEach((option) => {
      option.addEventListener('change', (event) => {
        const { dataset } = event.target;
        updateBonusEntries(
          form,
          parseFloat(dataset.limitedSubscriptionCents) || 0,
          parseFloat(dataset.onetimeCents) || 0
        );
      });
    });
  };

  const initAll = () => document.querySelectorAll('[data-rtnu-abp-hero]').forEach(initHero);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
